<template class="roombox">
  <div class="roombox" v-if="room">
    <div class="header">
      <div class="backbtn" @click="backhome()">
        <van-icon name="arrow-left" color="#fff" size=".5rem" />
      </div>
      <div class="room-name">{{ room.lottery.title }} - {{ room.title }}</div>
    </div>
    <div class="panel" v-if="opendata" v-show="panelShow">
      <div class="sbf">
        <div class="item">
          <div class="nextexpect">
            第<span>{{ opendata.nextexpect }}</span
            >期开奖
          </div>
          <div class="cutdown">
            <van-count-down
              v-if="opendata.timeout > room.ftime"
              :time="parseInt(opendata.timeout) * 1000"
            />
            <b class="" v-else-if="opendata.timeout <= room.ftime && opendata.timeout > 0"
              >封盘中</b
            >
            <b class="" v-else="">开奖中</b>
          </div>
        </div>
        <div class="item">
          <div class="title1">账户余额</div>

          <div class="wallet">
            {{ $store.state.userInfo.balance }}
          </div>
        </div>
      </div>
      <div class="xbf" @click="openlist = !openlist">
        <div class="lastexpect">
          第<span>{{ opendata.expect }}</span
          >期开奖
        </div>
        <!-- 28 -->
        <div class="opencode l28code" v-if="room.lottery.type == 2">
          <div class="ball">
            {{ opendata.last.extend[0][0] }}
          </div>
          <div>+</div>
          <div class="ball">
            {{ opendata.last.extend[0][1] }}
          </div>
          <div>+</div>
          <div class="ball">
            {{ opendata.last.extend[0][2] }}
          </div>
          <div>=</div>
          <div class="ball" :class="opendata.last.extend[4]">
            {{ opendata.last.extend[1] }}
          </div>
          <div class="text">
            {{ opendata.last.extend[2] }}
          </div>
        </div>
        <div class="opencode l6hcode" v-else-if="room.lottery.type == 1">
          <div>
            <div class="ball" :class="opendata.last.extend[0][1]">
              {{ opendata.last.extend[0][0] }}
            </div>
            <p>{{ opendata.last.extend[0][2] }}/{{ opendata.last.extend[0][3] }}</p>
          </div>
          <div>
            <div class="ball" :class="opendata.last.extend[1][1]">
              {{ opendata.last.extend[1][0] }}
            </div>
            <p>{{ opendata.last.extend[1][2] }}/{{ opendata.last.extend[1][3] }}</p>
          </div>
          <div>
            <div class="ball" :class="opendata.last.extend[2][1]">
              {{ opendata.last.extend[2][0] }}
            </div>
            <p>{{ opendata.last.extend[2][2] }}/{{ opendata.last.extend[2][3] }}</p>
          </div>
          <div>
            <div class="ball" :class="opendata.last.extend[3][1]">
              {{ opendata.last.extend[3][0] }}
            </div>
            <p>{{ opendata.last.extend[3][2] }}/{{ opendata.last.extend[3][3] }}</p>
          </div>
          <div>
            <div class="ball" :class="opendata.last.extend[4][1]">
              {{ opendata.last.extend[4][0] }}
            </div>
            <p>{{ opendata.last.extend[4][2] }}/{{ opendata.last.extend[4][3] }}</p>
          </div>
          <div>
            <div class="ball" :class="opendata.last.extend[5][1]">
              {{ opendata.last.extend[5][0] }}
            </div>
            <p>{{ opendata.last.extend[5][2] }}/{{ opendata.last.extend[5][3] }}</p>
          </div>
          <div>+</div>
          <div>
            <div class="ball" :class="opendata.last.extend[6][1]">
              {{ opendata.last.extend[6][0] }}
            </div>
            <p>{{ opendata.last.extend[6][2] }}/{{ opendata.last.extend[6][3] }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="chatbox" id="chatbox">
      <div class="message" :class="i.left == 0 ? 'mine' : ''" v-for="i in chatdata">
        <div class="avatar">
          <img :src="i.avatar" />
        </div>
        <div class="content">
          <p class="nickname">{{ i.author }}</p>
          {{ i.content }}
        </div>
      </div>
    </div>

    <div class="footer" v-if="room.lottery.type == 2">
      <div class="full-input" v-if="opendata.timeout < room.ftime">封盘中禁止投注</div>
      <div class="tools" v-else>
        <div class="order-input">
          <input placeholder="请输入文字指令下注" v-model="keyboard" />
          <van-icon
            name="apps-o"
            size="0.4rem"
            @click="
              playgroup = 0;
              playbox = true;
            "
          />
        </div>
        <div class="order-btn" @click="sendMsg()">发送</div>
      </div>
    </div>

    <div class="footer" v-else-if="room.lottery.type == 1">
      <div class="full-input" v-if="opendata.timeout < room.ftime">封盘中禁止投注</div>
      <div
        class="full-input active-input"
        @click="
          playgroup = 0;
          playbox = true;
        "
        v-else
      >
        下注
      </div>
    </div>

    <van-popup
      v-model:show="playbox"
      position="bottom"
      :style="{ height: 'calc(100% - 165px)' }"
      :overlay-style="{ background: 'none' }"
      z-index="2008"
    >
      <div class="playbox">
        <div class="header">
          信用投注
          <van-icon id="closebtn" name="arrow-down" @click="playbox = false" size="20" />
        </div>
        <div class="body">
          <div class="left">
            <div
              :class="playgroup == index ? 'active' : ''"
              v-for="(item, index) in room.playbox"
              @click="
                selectIds = [];
                selectNumbers = [];
                playgroup = index;
              "
            >
              <div v-if="playgroup == index" class="active-flag"></div>
              {{ item.name }}
            </div>
          </div>
          <div class="right">
            <div class="title">
              {{ room.playbox[playgroup].name }}
              <van-icon name="question-o" @click="showHelp = true" />
            </div>
            <div class="plays">
              <div v-for="i in room.playbox[playgroup].childrens">
                <div
                  class="btn"
                  :class="selectIds.indexOf(i.id) == -1 ? '' : 'active'"
                  @click="selectId(i.id, room.playbox[playgroup].special)"
                >
                  {{ i.playtitle }}
                  <p>{{ i.odds }}</p>
                </div>
              </div>

              <div
                v-if="room.playbox[playgroup].special > 0 && selectIds.length > 0"
                style="width: 100%; border-top: 1px dashed #158bf4; padding-top: 10px"
              >
                <div class="number" v-for="k in 49">
                  <div class="btn" :class="selectNumbers.indexOf(k) == -1 ? '' : 'active'" @click="selectNumber(k)">
                    {{ k }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="f1">
            共{{ selectIds.length }}单, 合计{{ parseFloat(selectIds.length * total) }}{{ $t('元') }}
          </div>
          <div class="f2">
            <div class="trash" @click="selectIds = [];selectNumbers = []">
              <van-icon name="delete" size=".5rem" color="#cccccc" />
            </div>
            <div class="quick">
              <div @click="total = 10">10</div>
              <div @click="total = 20">20</div>
              <div @click="total = 50">50</div>
              <div @click="total = 200">200</div>
              <div @click="total = 500">500</div>
            </div>
            <div class="input">
              <input v-model="total" type="number" />
            </div>
          </div>
          <div class="f3">
            <div class="lastorder">最近投注</div>
            <div class="submitorder" @click="previewOrder()">立即投注</div>
          </div>
        </div>
      </div>
    </van-popup>

    <van-dialog
      v-model:show="showHelp"
      title="玩法介绍"
      :message="room.playbox[playgroup].desc"
      confirm-button-color="#158bf4"
      :close-on-click-overlay="true"
      :allow-html="true"
    >
    </van-dialog>

    <van-dialog
      v-model:show="showPreview"
      title="投注确认"
      confirm-button-color="#158bf4"
      :show-cancel-button="true"
      :close-on-click-overlay="true"
      @confirm="createOrder()"
    >
      <div class="preview" v-for="(i, index) in order">
        <div class="p1">{{ i[0] }}</div>
        <div class="p2">{{ i[1].playtitle }}</div>
        <div class="p3">
          <input v-model="i[2]" />
          <van-icon class="remove" name="minus" @click="removePreview(index)" />
        </div>
      </div>
      <div style="padding: 0 10px">共{{ order.length }}单, 合计{{ getAmount() }}{{ $t('元') }}</div>
    </van-dialog>

    <van-popup
      v-model:show="openlist"
      position="top"
      :style="{ height: '335px', marginTop: '165px' }"
      :overlay-style="{ background: 'none' }"
      z-index="2000"
    >
      <div class="l28list" v-if="room.lottery.type == 2">
        <div class="row">
          <div>期号</div>
          <div>时间</div>
          <div class="opencode">开奖结果</div>
        </div>
        <div class="row" v-for="item in room.lottery.openlist">
          <div>{{ item.expect }}</div>
          <div>{{ item.opentime2 }}</div>
          <div class="opencode">
            <div class="ball">
              {{ item.extend[0][0] }}
            </div>
            <div>+</div>
            <div class="ball">
              {{ item.extend[0][1] }}
            </div>
            <div>+</div>
            <div class="ball">
              {{ item.extend[0][2] }}
            </div>
            <div>=</div>
            <div class="ball" :class="item.extend[4]">
              {{ item.extend[1] }}
            </div>
            <div class="text">
              {{ item.extend[2] }}
            </div>
          </div>
        </div>
      </div>
      <div class="l6hlist" v-if="room.lottery.type == 1">
        <div class="row">
          <div>期号</div>
          <div>时间</div>
          <div class="opencode">开奖结果</div>
        </div>
        <div class="row" v-for="item in room.lottery.openlist">
          <div>{{ item.expect }}</div>
          <div>{{ item.opentime2 }}</div>
          <div class="opencode">
            <div>
              <div class="ball" :class="item.extend[0][1]">
                {{ item.extend[0][0] }}
              </div>
            </div>
            <div>
              <div class="ball" :class="item.extend[1][1]">
                {{ item.extend[1][0] }}
              </div>
            </div>
            <div>
              <div class="ball" :class="item.extend[2][1]">
                {{ item.extend[2][0] }}
              </div>
            </div>
            <div>
              <div class="ball" :class="item.extend[3][1]">
                {{ item.extend[3][0] }}
              </div>
            </div>
            <div>
              <div class="ball" :class="item.extend[4][1]">
                {{ item.extend[4][0] }}
              </div>
            </div>
            <div>
              <div class="ball" :class="item.extend[5][1]">
                {{ item.extend[5][0] }}
              </div>
            </div>
            <div style="width: 10px">+</div>
            <div>
              <div class="ball" :class="item.extend[6][1]">
                {{ item.extend[6][0] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { showDialog } from "vant";
import {translateText} from "../../common/utils";
export default {
  name: "lotteryPage",
  data() {
    return {
      room_id: null,
      room: null,
      order: [],
      opendata: null,
      panelShow: true,
      timer: false,
      keyboard: null,
      playbox: false,
      openlist: false,
      total: 10,
      playgroup: 0,
      selectIds: [],
      selectNumbers: [],
      showHelp: false,
      help_allow_html: true,
      showPreview: false,
      chatdata: [],
      playdata: [],
      wss: null
    };
  },
  created() {
    var _that = this;
    var query = _that.$route.query;
    _that.room_id = query.room_id;

    let token = localStorage.getItem("token") ? localStorage.getItem("token") : "";

    if (!token) {
      setTimeout(() => {
        _that.showTost(0, "请登录！");
        _that.$parent.goNav(`/`);
      }, 1000);
      return;
    }

    _that.getLottery();
    _that.startTimer();
  },

  methods: {
    async showTost(type = 0, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    // 获取房间信息
    getLottery: function () {
      var _that = this;
      if (_that.room == null) {
        _that.$parent.showLoading();
      }
      _that.$apiFun
        .get("/api/lotteryRoom?room_id=" + _that.room_id)
        .then((res) => {
          _that.room = res.data;
          _that.opendata = res.data.lottery.nowdata;
          if (_that.chatdata.length < 1)
          {
            for (let i = 0; i < res.data.chatdata.length; i++)
            {
              let tmp = res.data.chatdata[i]
              let left = tmp.user_id != _that.$store.state.userInfo.id ? 1 : 0;
              _that.chatdata.push({
                left: left,
                author: tmp.author,
                avatar: tmp.headurl,
                content: tmp.content
              })
            }

            setTimeout(() => {
              _that.createWssClient()
              let chatbox = document.getElementById('chatbox')
              chatbox.scrollTop = chatbox.scrollHeight
            }, 500)
           }
          _that.$parent.hideLoading();
        })
        .catch((res) => {
          _that.$parent.hideLoading();
        });
    },

    // 获取房间消息
    getRoomMessage: function () {

    },

    // 连接房间服务
    createWssClient: function () {
      let wss_url = localStorage.getItem("baseURL") + '/wss?roomid=' + this.room_id + '&_token=' + localStorage.getItem("token")
      this.wss = new WebSocket(wss_url)
      var _that = this

      setInterval(() => {
        _that.wss.send("ping");
      }, 3000)

      this.wss.addEventListener("message", function (event) {
        if (event.data == 'ping')
        {
          return
        }

        let data = JSON.parse(event.data)
        if (data.sysmsg !== false) {
          _that.showTost(parseInt(data.sysmsg), data.content);
        } else {
          _that.msgReceive(data.id, data.author, data.avatar, data.content)
        }
      });
    },

    selectId: function (id, special = 0) {
      if (special == 1) {
        this.selectIds = [];
        this.selectNumbers = [];
      }

      let index = this.selectIds.indexOf(id);
      if (index == -1) {
        this.selectIds.push(id);
      } else {
        this.selectIds.splice(index, 1);
      }
    },

    selectNumber: function (k) {
      let index = this.selectNumbers.indexOf(k);
      if (index == -1) {
        this.selectNumbers.push(k);
      } else {
        this.selectNumbers.splice(index, 1);
      }
    },

    startTimer: function () {
      var _that = this;
      _that.timer = setInterval(() => {
        _that.opendata && _that.opendata.timeout--;
        if (_that.opendata && _that.opendata.timeout < _that.room.ftime) {
          _that.playbox = false;
        }

        if (_that.opendata && _that.opendata.timeout < 0) {
          _that.getLottery();
        }
      }, 1000);
    },

    previewOrder: function () {
      this.order = [];

      for (let i = 0; i < this.room.playbox[this.playgroup].childrens.length; i++) {
        let tmp = this.room.playbox[this.playgroup].childrens[i];
        if (this.selectIds.indexOf(tmp.id) != -1) {
          this.order.push({
            0: this.room.playbox[this.playgroup].name,
            1: tmp,
            2: this.total,
          });
        }
      }

      if (this.order.length > 0) {
        this.showPreview = true;
      }
    },

    removePreview: function (index) {
      this.order.splice(index, 1);
      if (this.order.length < 1) {
        this.showPreview = false;
      }
    },

    // 提交投注
    createOrder: function () {
      let _that = this;
      if (_that.order.length > 0) {
        let data = [];
        for (let i = 0; i < _that.order.length; i++) {
          data.push({
            id: _that.order[i][1].id,
            total: _that.order[i][2],
            data: [],
          });
        }
        _that.$parent.showLoading();
        _that.$apiFun
          .post("/api/lotteryOrder", {
            room_id: _that.room_id,
            order: data,
            expect: _that.opendata.nextexpect,
          })
          .then((res) => {
            if (res.code == 200) {
              _that.showTost(1, "投注成功");
              _that.selectIds = [];
              _that.msgPush(res.data, 0)
            } else {
              _that.showTost(0, res.message);
            }
            _that.$parent.hideLoading();
          })
          .catch((res) => {
            console.log(res);
            _that.$parent.hideLoading();
          });
      }
    },

    backhome: function () {
      window.location.href = "/";
    },

    sendMsg: function () {
      if (this.keyboard != null && this.keyboard.length > 0) {
        this.msgPush(this.keyboard)
        this.keyboard = null
      }
    },

    msgPush: function (msg, order = 1) {
      let params = {
        left: 0,
        author: this.$store.state.userInfo.username,
        avatar: this.$store.state.userInfo.avatar,
        content: msg
      }

      this.chatdata.push(params)
      let chatbox = document.getElementById('chatbox')
      chatbox.scrollTop = chatbox.scrollHeight
      this.wss.send(JSON.stringify({
        content: msg,
        order: order
      }))
    },

    msgReceive: function (id, author, avatar, msg) {
      let left = id != this.$store.state.userInfo.id ? 1 : 0;
      this.chatdata.push({
        left: left,
        author: author,
        avatar: avatar,
        content: msg
      })
    },

    getAmount: function () {
      let sum = 0;

      for (let i = 0; i < this.order.length; i++) {
        sum += parseFloat(this.order[i][2]);
      }

      return sum;
    },
  },
};
</script>

<style lang="scss" scoped>
.roombox {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.04);

  .header {
    position: relative;
    width: 100%;
    height: 45px;
    background: #158bf4;
    z-index: 2005;

    .backbtn {
      position: absolute;
      width: 45px;
      height: 45px;
      top: 0;
      left: 0;
      align-content: center;
      text-align: center;
    }

    .room-name {
      position: absolute;
      left: 25%;
      width: 50%;
      height: 100%;
      line-height: 45px;
      text-align: center;
      color: #fff;
      font-size: 0.4rem;
    }
  }

  .panel {
    position: relative;
    width: 100%;
    height: 120px;
    background: #fff;
    padding-top: 10px;
    z-index: 2005;

    .sbf {
      width: 100%;
      height: 60px;
      padding-bottom: 10px;
      display: flex;
      border-bottom: 1px solid #d1d1d1;

      .item {
        position: relative;
        width: calc(50% - 1px);
        height: 100%;
        border-right: 1px solid #d1d1d1;
      }

      .item:last-child {
        border: 0;
      }

      .nextexpect {
        position: absolute;
        width: 100%;
        height: 20px;
        text-align: center;
        top: calc(50% - 25px);
        font-size: 0.32rem;

        span {
          font-size: 0.3rem;
          color: #158bf4;
        }
      }

      .cutdown {
        width: 60px;
        margin: 30px auto;
        margin-bottom: 0;
        padding: 5px 10px;
        background: #576b65;
        text-align: center;
        border-radius: 6px;

        .van-count-down {
          color: #fff;
        }

        b {
          color: #fff;
        }
      }

      .title1 {
        position: absolute;
        width: 100%;
        height: 20px;
        text-align: center;
        top: calc(50% - 25px);
        font-size: 0.32rem;
      }

      .wallet {
        position: absolute;
        width: 100%;
        height: 20px;
        text-align: center;
        top: calc(50% + 5px);
        font-size: 0.35rem;
        color: orange;
      }
    }

    .xbf {
      padding: 10px;
      height: 20px;
      line-height: 30px;
      margin-top: 5px;

      .lastexpect {
        float: left;
        width: auto;
        height: 20px;
        line-height: 20px;
        font-size: 0.32rem;

        span {
          font-size: 0.3rem;
          color: #158bf4;
        }
      }

      .opencode {
        display: flex;
        // margin-left: 20px;
        float: right;

        div {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          text-align: center;
          line-height: 20px;
        }

        .text {
          width: auto;
          margin: 0 10px;
        }
      }

      .l28code {
        .ball {
          background: #158bf4;
          color: #fff;
        }
      }

      .l6hcode {
        margin-top: -8px;

        div {
          width: 30px;
          height: 15px;

          .ball {
            width: 20px;
            height: 20px;
            color: #fff;
            border-radius: 50%;
            margin: 0 auto;
          }

          p {
            margin-block: 0 !important;
          }
        }
      }
    }
  }

  .chatbox {
    width: calc(100% - 20px);
    height: calc(100% - 260px);
    padding: 10px;
    padding-bottom: 20px;
    overflow-y: auto;

    .message {
      display: flex;
      width: 100%;
      margin-bottom: 10px;

      .avatar {
        width: 60px;
        height: 60px;
        border-radius: 50%;

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }

      .content {
        margin-left: 10px;
        font-size: 0.3rem;

        .nickname {
          font-size: 0.4rem;
          margin-block-start: 0 !important;
          width: 100%;
        }
      }
    }

    .mine {
      flex-direction: row-reverse;
      .content {
        margin-left: 0;
        margin-right: 10px;
        .nickname {
          text-align: right;
        }
      }
    }
  }

  .footer {
    width: 100%;
    height: 45px;

    .full-input {
      width: 95%;
      height: 45px;
      margin: 0 auto;
      background: #fff;
      border-radius: 22.5px;
      text-align: center;
      line-height: 45px;
      color: #d1d1d1;
      font-size: 0.45rem;
    }

    .active-input {
      background: #158bf4;
      color: #fff;
    }

    .tools {
      .order-input {
        float: left;
        position: relative;
        width: calc(100% - 5% - 70px);
        height: 45px;
        margin: 0 5px 0 2.5%;
        border-radius: 20px;
        background: #fff;

        input {
          width: 88%;
          height: 100%;
          border: 0;
          box-shadow: none;
          box-sizing: unset;
          border-radius: 20px;
          text-indent: 15px;
          font-size: 0.35rem;
        }

        .openapp {
        }
      }

      .order-btn {
        float: left;
        width: 60px;
        height: 45px;
        margin-left: 10px;
        background: #158bf4;
        color: #fff;
        border-radius: 20px;
        text-align: center;
        line-height: 45px;
        font-size: 0.37rem;
      }
    }
  }

  .l28list {
    padding-top: 5px;

    .row {
      height: 30px;

      div {
        float: left;
        width: 20%;
        text-align: center;
        line-height: 30px;
      }

      .opencode {
        width: 60%;
        display: flex;
        justify-content: center;

        div {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          text-align: center;
          line-height: 20px;
        }

        .ball {
          background: #158bf4;
          color: #fff;
        }

        .text {
          width: auto;
          margin: 0 10px;
        }
      }
    }
  }

  .l6hlist {
    padding-top: 5px;

    .row {
      height: 30px;

      div {
        float: left;
        width: 20%;
        text-align: center;
        line-height: 30px;
      }

      .opencode {
        width: 60%;
        display: flex;
        justify-content: center;

        div {
          width: 30px;
          height: 30px;

          .ball {
            width: 20px;
            height: 20px;
            line-height: 20px;
            color: #fff;
            border-radius: 50%;
            margin: 5px;
          }

          p {
            width: auto;
            margin-block: 0 !important;
          }
        }
      }
    }
  }

  .playbox {
    height: 100%;

    .header {
      position: relative;
      background: #fff;
      border-top: 1px solid #d1d1d1;
      border-bottom: 1px solid #d1d1d1;
      height: 40px;
      line-height: 40px;
      color: #000;
      text-align: center;
      font-size: 0.36rem;

      #closebtn {
        position: absolute;
        left: 10px;
        top: 10px;
      }
    }

    .body {
      width: 100%;
      height: calc(100% - 40px - 100px - 2px);
      background: rgba(0, 0, 0, 0.04);
      display: flex;

      .left {
        width: 70px;
        height: 100%;
        background: #fff;

        div {
          width: 70px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          border-bottom: 1px solid #d1d1d1;
        }

        .active {
          position: relative;
          background: rgba(#158bf4, 0.04);
          color: #158bf4;

          .active-flag {
            position: absolute;
            width: 4px;
            height: 50%;
            left: 0;
            top: 25%;
            background: #158bf4;
          }
        }
      }

      .right {
        width: calc(100% - 90px);
        height: calc(100% - 20px);
        padding: 10px;

        .title {
          position: relative;
          height: 30px;
          font-weight: bold;
          font-size: 0.35rem;
        }

        .plays {
          width: calc(100%);
          height: calc(100% - 30px);
          float: left;
          overflow-y: auto;

          div {
            float: left;
            width: 25%;
            height: 40px;
            margin-bottom: 10px;

            .btn {
              float: none;
              width: 60px;
              height: 40px;
              border: 1px solid #158bf4;
              margin: 0 auto;
              border-radius: 6px;
              text-align: center;
              display: grid;
              align-items: center;
              font-size: 0.3rem;
              color: #000;

              p {
                font-size: 0.25rem;
                color: #000;
                margin-block: 0 !important;
              }
            }

            .active {
              background: #158bf4;
              color: #fff;
              p {
                color: #fff;
              }
            }
          }

          .number {
            width: 14%;
            height: 20px;

            .btn {
              width: 90%;
              height: 20px;
            }

            .active {
              background: #158bf4;
              color: #fff;
              p {
                color: #fff;
              }
            }
          }
        }
      }
    }

    .footer {
      width: 100%;
      height: 100px;

      .f1 {
        width: 100%;
        height: 25px;
        line-height: 25px;
        text-align: center;
        color: red;
      }

      .f2,
      .f3 {
        width: 100%;
        height: 40px;
        text-align: center;
      }

      .f2 {
        height: 30px;
        display: flex;
        justify-content: space-around;

        .trash {
          width: 10%;
          height: 30px;
          background: rgb(243, 246, 255);
          align-content: center;
          border-radius: 5px;
          border: 1px solid #d1d1d1;
        }

        .quick {
          width: 60%;
          height: 30px;
          background: rgb(243, 246, 255);
          border-radius: 5px;
          display: flex;
          border: 1px solid #d1d1d1;

          div {
            width: 20%;
            line-height: 30px;
            color: #000;
            border-right: 1px solid #d1d1d1;
          }

          div:last-child {
            border: 0;
          }
        }

        .input {
          width: 20%;
          height: 30px;
          background: rgb(243, 246, 255);
          border-radius: 5px;
          border: 1px solid #d1d1d1;

          input {
            width: 90%;
            height: 25px;
            box-shadow: none;
            box-sizing: unset;
            border-radius: 6px;
            font-size: 0.35rem;
            background: none;
            text-align: center;
            border: 0;
          }
        }
      }

      .f3 {
        display: flex;
        justify-content: space-around;

        .lastorder {
          width: 20%;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background: rgb(243, 246, 255);
          border: 1px solid #d1d1d1;
          border-radius: 6px;
          margin-top: 10px;
        }

        .submitorder {
          width: 60%;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background: #158bf4;
          color: #fff;
          border: 1px solid #d1d1d1;
          border-radius: 6px;
          margin-top: 10px;
        }
      }
    }
  }
}

.red {
  background: red !important;
}

.blue {
  background: blue !important;
}

.green {
  background: green !important;
}

.preview {
  padding: 10px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .p1 {
    width: 20%;
    text-align: center;
    padding: 2px 5px;
    background: #158bf4;
    color: #fff;
  }

  .p2 {
    color: #000;
    text-align: center;
    width: 40%;
  }

  .p3 {
    width: 30%;
    text-align: right;

    input {
      width: 55%;
      border: 1px solid #d1d1d1;
      box-shadow: none;
      box-sizing: unset;
      border-radius: 6px;
      text-indent: 15px;
      font-size: 0.3rem;
    }

    .remove {
      margin-left: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/lotteryPage.vue